import { Chip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getStatusColorClasses } from '../DeviationList';
import { ReactComponent as PenIcon } from 'atoms/icons/svg/pen.svg';
import { HoleDectionListItem } from 'models/holeDetection';
import './MobileList.scss';

type Props = {
  row: HoleDectionListItem;
};

const MobileList: FC<Props> = ({ row }) => {
  const { t } = useTranslation();
  const {
    acknowledged_by_customer,
    pen_code,
    horizontal_line_breaks,
    vertical_line_breaks,
    position,
    depth,
    escape_risk,
  } = row;

  const status = getStatusColorClasses(escape_risk, acknowledged_by_customer);

  return (
    <div className={`deviation-mobile-item ${status}`}>
      <div className="deviation-mobile-item--section">
        <div className="section-top">
          <div className="status">
            <span className={`${status} status-circle`} />
            <span className="status-title">
              {acknowledged_by_customer ? t('Confirmed') : t('New')}
            </span>
          </div>

          <div className="pen">
            <PenIcon /> {t('Pen')} {pen_code}
          </div>
        </div>
        <div className="section-bottom">
          <div className="mask-position">
            <div className="mask">{`${horizontal_line_breaks ?? 0} x ${vertical_line_breaks ?? 0} ${t('masks')}`}</div>
            <div className="position">
              <span className="label">{t('Position')}:</span>
              <span className="value"> {`${position}° | ${depth}m`}</span>
            </div>
          </div>

          <div className="net-damage">
            <Chip
              label={
                escape_risk ? t('Major net damage') : t('Small net damage')
              }
              className={escape_risk ? 'risk-colour' : ''}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileList;
